let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("chSc4")).then(() => parcelRequire('10LAa'));